<template>
  <div class="nyuusya-date detail-item" v-if="editingData">

    <div class="head"><b>入社日</b></div>
    <!-- 新規入社の場合はユーザーテーブルにレコードが無い為、入社日 === 契約日を表示する -->
    <div class="data">
      <p>{{ date }}</p>
      <p>{{ notice }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import OptionConst from '@/const/Option';
import { computed, ref } from '@vue/reactivity';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  },
  setup(props) {
    const notice = ref('')
    const date = computed(() => {
      if(!props.editingData){
        return '-'
      }
      
      if (
        props.editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ENTRY ||
        props.editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY
      ) {
        notice.value = '※この申請種別では「雇用期間の開始日」が自動設定されます'
        return props.editingData.keiyaku_date
      } else {
        notice.value = '※この申請種別では「社員マスタ上の入社日」が自動設定されます'
        return props.editingData.nyuusya_date
      }

    })
    return {
      OptionConst,
      date,
      notice
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
